export default __webpack_public_path__ + "images/kolor_active.png";